(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function placeSwatchText() {
      document.querySelectorAll('product-card > .swatches-globo--list').forEach(function (list) {
        var card = list.parentElement;
        var group = card.querySelector('.product-card-group');
        if (!group) return;
        var price = group.querySelector('product-price') || group.querySelector('[class*="price"]');
        var anchor = price;
        while (anchor && anchor.parentElement !== group) anchor = anchor.parentElement;
        if (anchor) anchor.after(list);
      });
    }

    placeSwatchText();
    new MutationObserver(placeSwatchText).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
